(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_carousel-content"] && !Shopify.designMode) return;
  try {
    class CarouselProgress extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.carousel-progress__track');
      this.thumb = this.querySelector('.carousel-progress__thumb');
      this.root = this.closest('.carousel-nav-wrapper');
      if (!this.track || !this.thumb || !this.root) return;

      this.update = this.update.bind(this);
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this);
      requestAnimationFrame(this.update);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.scroller?.removeEventListener('scroll', this.update);
    }

    getScroller() {
      if (this.scroller?.isConnected) return this.scroller;

      const candidates = this.root.querySelectorAll('slideshow-slides, [class*="slides"]');
      for (const el of candidates) {
        if (el.scrollWidth - el.clientWidth > 1) {
          this.scroller = el;
          el.addEventListener('scroll', this.update, { passive: true });
          this.observer.observe(el);
          return el;
        }
      }
      return null;
    }

    update() {
      const slides = this.getScroller();
      if (!slides) return;

      const max = slides.scrollWidth - slides.clientWidth;
      const trackWidth = this.track.clientWidth;

      if (max <= 1 || trackWidth === 0) {
        this.hidden = true;
        return;
      }

      this.hidden = false;
      const ratio = slides.clientWidth / slides.scrollWidth;
      const thumbWidth = Math.max(24, Math.round(trackWidth * ratio));
      const progress = Math.min(1, Math.max(0, Math.abs(slides.scrollLeft) / max));

      this.thumb.style.width = `${thumbWidth}px`;
      this.thumb.style.transform = `translateX(${progress * (trackWidth - thumbWidth)}px)`;
    }
  }

  if (!customElements.get('carousel-progress')) {
    customElements.define('carousel-progress', CarouselProgress);
  }
  } catch(e) { console.error(e); }
})();

})();
